<template>
  <component :is="refundData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="refundData === undefined">
      <h4 class="alert-heading">獲取退款數據時出錯</h4>
      <div class="alert-body">
        找不到相關退款記錄。請查看
        <b-link class="alert-link" :to="{ name: 'refunds-list' }">
          退款列表
        </b-link>
      </div>
    </b-alert>
    <refund-edit-tab-information
      v-if="refundData"
      :receipt-options="receiptOptions"
      :project-options="projectOptions"
      :customer-options="customerOptions"
      :refund-data="refundData"
      :loading="loading"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import refundStoreModule from "../refundStoreModule";
import refundEditTabInformation from "./refundEditTabInformation.vue";

export default {
  components: {
    refundEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const refundData = ref({ id: 0 });
    const refund = {
      id: 0,
      refund_items: [{ id: 0 }],
      refund_date: new Date().toISOString().substr(0, 10)
    };

    const refund_APP_STORE_MODULE_NAME = "refund";

    if (!store.hasModule(refund_APP_STORE_MODULE_NAME))
      store.registerModule(refund_APP_STORE_MODULE_NAME, refundStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(refund_APP_STORE_MODULE_NAME))
        store.unregisterModule(refund_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "refund-create" || router.currentRoute.name == "refund-customer-create") {
        refundData.value = { ...refund };

        // 如果是客戶自主退款，自動設定客戶 ID
        if (router.currentRoute.name == "refund-customer-create") {
          const userData = JSON.parse(localStorage.getItem('userData') || '{}');
          if (userData.user_type_id === 2 && userData.id) {
            refundData.value.customer_id = userData.id;
          }
        }
        loading.value=false
      } else {
        store
          .dispatch("refund/fetchRefund", { id: router.currentRoute.params.id })
          .then((response) => {
            refundData.value = response.data.refund;
            console.log(refundData.value)
            loading.value=false
          })
          .catch((error) => {
            loading.value=false
            console.log("error when fetching refund", error);
            if (error.response.status === 404) {
              refundData.value = undefined;
            }
          });
      }
    };

    const loading = ref(false);

    const receiptOptions = ref([]);
    const projectOptions = ref([]);
    const customerOptions = ref([]);

    const refetchOption = () => {
      loading.value = true
      store
        .dispatch("app/fetchOptionList", {
          receipts:true,
          projects: true,
          customers: true,
        })
        .then((response) => {
          receiptOptions.value = response.data.receipts;
          projectOptions.value = response.data.projects;
          customerOptions.value = response.data.customers;
          refetchData();
        });
    };

    onMounted(() => {
      refetchOption();
    });

    return {
      receiptOptions,
      projectOptions,
      customerOptions,
      refundData,
      refetchData,
      refetchOption,
      loading
    };
  },
};
</script>
